/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 12,
    height: 15,
    viewBox: '0 0 12 15',
    data: '<path pid="0" class="st0" d="M9 3.4c0 1.9-1.5 3.4-3.4 3.4S2.2 5.2 2.2 3.4 3.8 0 5.6 0 9 1.5 9 3.4z"/><path pid="1" class="st2" d="M5.9 7.6c-2.1 0-4.1 1.1-5.4 2.9C-.9 12.4.5 15 2.8 15h6.3c2.3 0 3.6-2.6 2.3-4.5C10 8.7 8.1 7.6 5.9 7.6z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/user.js